import { render, staticRenderFns } from "./PickRenewalTemplatePage.vue?vue&type=template&id=0840ab14&scoped=true"
import script from "./PickRenewalTemplatePage.vue?vue&type=script&lang=js"
export * from "./PickRenewalTemplatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0840ab14",
  null
  
)

export default component.exports